import alIcon from '../assets/al-icon.png'
import alHeadIcon from '../assets/al-head-icon.png'
import allanbot from '../assets/allanbot.gif'
import betaIcon from '../assets/beta-icon.png'

interface AiAgentLogoProps {
  className?: string
  size?: number
  iconType?: 'default' | 'head' | 'animated'
}

function AiAgentLogo({
  className = 'ai-agent-avatar-small',
  size = 28,
  iconType = 'default',
}: AiAgentLogoProps) {
  let src = alIcon
  if (iconType === 'head') src = alHeadIcon
  if (iconType === 'animated') src = allanbot

  const badgeSize = iconType === 'animated' ? Math.max(size * 0.25) : Math.max(size * 0.6)

  if (iconType === 'head') {
    return (
      <img
        src={src}
        alt='Allan bot'
        className={className}
        style={{ width: size }}
        data-testid='ai-agent-logo'
      />
    )
  }
  return (
    <span style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
      <img
        src={src}
        alt='Allan bot'
        className={className}
        style={{ width: size }}
        data-testid='ai-agent-logo'
      />

      <img
        src={betaIcon}
        alt='Beta'
        style={{
          position: 'absolute',
          bottom: -2,
          left: '80%',
          transform: 'translateX(-70%)',
          width: badgeSize,
          height: 'auto',
          pointerEvents: 'none',
        }}
      />
    </span>
  )
}

export { AiAgentLogo }
